import React from "react";
import { motion } from "framer-motion";
import {
  RadialBarChart,
  RadialBar,
  PolarAngleAxis,
  ResponsiveContainer,
} from "recharts";

interface GaugeWidgetProps {
  label: string;
  value: number;
  color: string;
  icon: React.FC<any>;
  subtitle?: string;
}

const GaugeWidget: React.FC<GaugeWidgetProps> = ({
  label,
  value,
  color,
  icon: Icon,
  subtitle,
}) => {
  const clampedValue = Math.max(0, Math.min(100, value));
  const chartData = [{ name: label, value: clampedValue, fill: color }];

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl shadow-sm border border-slate-200 p-5"
    >
      {/* Header */}
      <div className="flex items-center gap-2 mb-2">
        <div
          className="p-2 rounded-lg"
          style={{ backgroundColor: `${color}1A` }}
        >
          <Icon className="h-4 w-4" style={{ color }} />
        </div>
        <h3 className="text-sm font-semibold text-slate-700 m-0 leading-none">{label}</h3>
      </div>

      {/* Gauge */}
      <div className="relative w-full" style={{ height: 140 }}>
        <ResponsiveContainer width="100%" height="100%">
          <RadialBarChart
            cx="50%"
            cy="50%"
            innerRadius="70%"
            outerRadius="90%"
            barSize={12}
            data={chartData}
            startAngle={90}
            endAngle={-270}
          >
            {/* @ts-expect-error Recharts v3 PolarAngleAxis JSX return type mismatch */}
            <PolarAngleAxis
              type="number"
              domain={[0, 100]}
              angleAxisId={0}
              tick={false}
            />
            <RadialBar
              background={{ fill: "#e2e8f0" }}
              dataKey="value"
              cornerRadius={6}
              angleAxisId={0}
            />
          </RadialBarChart>
        </ResponsiveContainer>
        {/* Center percentage */}
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-2xl font-bold text-slate-800">
            {clampedValue}%
          </span>
        </div>
      </div>

      {/* Description below gauge */}
      {subtitle && (
        <div className="mt-2 py-2 px-3 rounded-lg bg-slate-50 text-center">
          <p className="text-xs font-medium text-slate-600">{subtitle}</p>
        </div>
      )}
    </motion.div>
  );
};

export default GaugeWidget;
